module.exports = __webpack_public_path__ + "img/dashboard.f09179b8.png";